import Breadcrumb from "../component/Breadcrumb";

export default function Resolutions() {
    return(<>
    <Breadcrumb title="Board Resolutions"/>
    <Breadcrumb title="Comming"/>
    </>)
}